import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const MODULE_PREFIX = '[MARKET WATCH]';

const Actions = {
	fetchMarketWatchData: `${MODULE_PREFIX} fetchMarketWatchData`,
	setMarketWatchData: `${MODULE_PREFIX} setMarketWatchData`,
	setStockLandingMarketWatchData: `${MODULE_PREFIX} setStockLandingMarketWatchData`,
	setSelectedMarketWatchIndex: `${MODULE_PREFIX} setSelectedMarketWatchIndex`,
	setMarketWatchPullRefreshState: `${MODULE_PREFIX} setMarketWatchPullRefreshState`,
	setSelectedMarketWatchTab: `${MODULE_PREFIX} setSelectedMarketWatchTab`,
	fetchMarketWatchGuestScripDetail: `${MODULE_PREFIX} fetchMarketWatchGuestScripDetail`,
};

// Action Creater
export const fetchMarketWatchData = createAction(Actions.fetchMarketWatchData);
export const setMarketWatchData = createAction(Actions.setMarketWatchData);
export const setStockLandingMarketWatchData = createAction(
	Actions.setStockLandingMarketWatchData,
);
export const setSelectedMarketWatchIndex = createAction(
	Actions.setSelectedMarketWatchIndex,
);
export const setMarketWatchPullRefreshState = createAction(
	Actions.setMarketWatchPullRefreshState,
);
export const setSelectedMarketWatchTab = createAction(
	Actions.setSelectedMarketWatchTab,
);
export const fetchMarketWatchGuestScripDetail = createAction(
	Actions.fetchMarketWatchGuestScripDetail,
);

export const getMarketWatchList = (state) => {
	return get(state, 'marketWatch.marketWatchData', {});
};

export const getStockLandingMarketWatchList = (state) => {
	return get(state, 'marketWatch.stockLandingMarketWatchData', []);
};

export const getSelectedMarketWatchIndex = (state) => {
	return get(state, 'marketWatch.selectedMarketWatchIndex', {});
};

export const getSelectedMarketWatchTab = (state) => {
	return get(state, 'marketWatch.selectedMarketWatchTab', '');
};

export const DEFAULT_SELECTED_INDEX = {
	name: 'NIFTY 50',
	id: 'Nifty 50',
	segment: 1,
};

// Initial state
const initialState = {
	marketWatchData: {},
	stockLandingMarketWatchData: [],
	selectedMarketWatchIndex: DEFAULT_SELECTED_INDEX,
	marketWatchPullRefreshState: {},
	selectedMarketWatchTab: '',
};

// Reducers
export default createReducer(initialState, (builder) => {
	builder.addCase(setMarketWatchData, (state, action) => {
		state.marketWatchData = action.payload;
	});
	builder.addCase(setStockLandingMarketWatchData, (state, action) => {
		state.stockLandingMarketWatchData = action.payload;
	});
	builder.addCase(setSelectedMarketWatchIndex, (state, action) => {
		state.selectedMarketWatchIndex = action.payload;
	});
	builder.addCase(setMarketWatchPullRefreshState, (state, action) => {
		state.marketWatchPullRefreshState = action.payload;
	});
	builder.addCase(setSelectedMarketWatchTab, (state, action) => {
		state.selectedMarketWatchTab = action.payload;
	});
});
